import styled from 'styled-components';

import { mediaUp, rem } from 'approot/shared/style';
import { orange1 } from 'approot/shared/styles/colours.style';
import { spacing16, spacing20 } from 'approot/shared/styles/spacing.style';
import { LayoutContentStyled } from '../layout/layout.styles';
import { ModalCloseButtonStyled } from 'approot/shared/styles/buttons/modal-close-button.style';
import { PStyled } from 'approot/shared/styles/typography.style';
import { Dropdown } from 'approot/shared/dropdown/dropdown.style';
import { LAYOUT_REGION_HEADER_Z_INDEX } from '../layout/layout.constants';

export const RegionsBanner = styled.div`
  background-color: ${orange1};
  position: sticky;
  width: 100vw;
  top: 0;
  z-index: ${LAYOUT_REGION_HEADER_Z_INDEX};
`;

export const RegionsBannerContent = styled(LayoutContentStyled)`
  padding-top: ${rem(spacing16)};
  padding-bottom: ${rem(spacing16)};
  padding-right: ${rem(60)};

  ${Dropdown} {
    min-width: ${rem(180)};
    max-width: ${rem(240)};
    margin: 0 ${rem(spacing16)} 0 0;
  }

  ${mediaUp.md`
    display: flex;
    align-items: center;
    justify-content: center;

    ${PStyled} {
      margin-bottom: 0;
    }

    ${Dropdown} {
      margin: 0 ${rem(spacing16)};
    }
  `}
`;

export const RegionsBannerControls = styled.div`
  display: flex;
  align-items: center;
`;

export const RegionsBannerClose = styled(ModalCloseButtonStyled)`
  top: ${rem(spacing20)};
`;
